// AUVRA RWA content data
import {
  ShieldCheck, FileCheck2, Cpu, Landmark, Coins, ArrowLeftRight,
  BarChart3, Store, Building2, Globe2, Users, Activity,
  Fingerprint, ScrollText, Scale, Lock, History, MapPin,
} from "lucide-react";

export const NAV_LINKS = [
  "Platform", "Tokenized Assets", "AUR Token", "Investors",
  "Partnerships", "Compliance", "Resources", "About", "Contact",
];

export const HERO_STATS = [
  { value: 2.8, prefix: "$", suffix: "B+", label: "Assets Tokenized" },
  { value: 47, suffix: "+", label: "Jurisdictions" },
  { value: 12000, suffix: "+", label: "Investors" },
  { value: 99.9, suffix: "%", label: "Uptime SLA" },
];

export const PLATFORM_FEATURES = [
  { icon: ShieldCheck, title: "Compliant by Design", desc: "Every issuance is wrapped in jurisdiction-aware compliance logic, from KYC to transfer restrictions." },
  { icon: Landmark, title: "Institutional Custody", desc: "Qualified custodians and multi-signature vaults secure the underlying real-world collateral." },
  { icon: Cpu, title: "Programmable Assets", desc: "Audited smart contracts automate dividends, redemptions and lifecycle events on-chain." },
  { icon: Globe2, title: "Global Distribution", desc: "Reach accredited investors across 47+ jurisdictions through a single unified rail." },
];

export const MARKET_STATS = [
  { value: 16, prefix: "$", suffix: "T", label: "Global RWA market by 2030" },
  { value: 3.7, prefix: "$", suffix: "T", label: "Tokenized real estate" },
  { value: 4.2, prefix: "$", suffix: "T", label: "Private equity & credit" },
  { value: 2.1, prefix: "$", suffix: "T", label: "Commodities & treasuries" },
];

export const TOKENOMICS = [
  { alloc: "Ecosystem & Rewards", pct: "30%", lockup: "6 mo", vesting: "36 mo", purpose: "Network incentives & liquidity" },
  { alloc: "Institutional Sale", pct: "22%", lockup: "12 mo", vesting: "24 mo", purpose: "Strategic capital partners" },
  { alloc: "Treasury", pct: "18%", lockup: "12 mo", vesting: "48 mo", purpose: "Protocol reserves & operations" },
  { alloc: "Team & Advisors", pct: "15%", lockup: "12 mo", vesting: "48 mo", purpose: "Core contributors" },
  { alloc: "Public Distribution", pct: "10%", lockup: "None", vesting: "12 mo", purpose: "Community access" },
  { alloc: "Liquidity", pct: "5%", lockup: "None", vesting: "6 mo", purpose: "Exchange & market depth" },
];

export const TECH_GRID = [
  { icon: Fingerprint, title: "Identity Verification" },
  { icon: FileCheck2, title: "Compliance Engine" },
  { icon: Cpu, title: "Smart Contracts" },
  { icon: Landmark, title: "Qualified Custody" },
  { icon: Coins, title: "Token Issuance" },
  { icon: ArrowLeftRight, title: "Instant Settlement" },
  { icon: BarChart3, title: "Real-time Reporting" },
  { icon: Store, title: "Secondary Markets" },
];

export const REGULATORY = [
  { icon: ShieldCheck, title: "KYC / KYB", desc: "Automated onboarding with global identity providers." },
  { icon: Scale, title: "AML Screening", desc: "Continuous sanctions and watchlist monitoring." },
  { icon: Users, title: "Accredited Investors", desc: "Programmatic accreditation and eligibility checks." },
  { icon: Lock, title: "Transfer Restrictions", desc: "On-chain rulesets enforce lockups and whitelists." },
  { icon: History, title: "Audit Trails", desc: "Immutable, regulator-ready transaction records." },
  { icon: MapPin, title: "Jurisdiction Controls", desc: "Geo-fencing and regional rule enforcement." },
];

export const PERFORMANCE = [
  { icon: Activity, value: 4.2, suffix: "M", label: "Transactions settled" },
  { icon: Building2, value: 320, suffix: "+", label: "Assets onboarded" },
  { icon: Users, value: 12000, suffix: "+", label: "Verified investors" },
  { icon: Globe2, value: 47, suffix: "+", label: "Countries served" },
  { icon: ArrowLeftRight, value: 1.4, suffix: "s", label: "Avg settlement" },
  { icon: Coins, value: 860, suffix: "+", label: "Token issuances" },
];

export const FEATURED_ASSETS = [
  {
    image: "https://images.unsplash.com/photo-1505843513577-22bb7d21e455?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwcm9wZXJ0eSUyMGV4dGVyaW9yJTIwbmlnaHR8ZW58MHx8fHwxNzg0MDM3ODY0fDA&ixlib=rb-4.1.0&q=85",
    location: "Zurich, Switzerland",
    name: "Lakeside Private Residence",
    value: "$48.5M",
    yield: "7.8%",
    status: "Open",
  },
  {
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBwcm9wZXJ0eSUyMGV4dGVyaW9yJTIwbmlnaHR8ZW58MHx8fHwxNzg0MDM3ODY0fDA&ixlib=rb-4.1.0&q=85",
    location: "Palo Alto, USA",
    name: "Modernist Estate Collection",
    value: "$31.2M",
    yield: "6.4%",
    status: "Open",
  },
  {
    image: "https://images.unsplash.com/photo-1748063578185-3d68121b11ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBwcm9wZXJ0eSUyMGV4dGVyaW9yJTIwbmlnaHR8ZW58MHx8fHwxNzg0MDM3ODY0fDA&ixlib=rb-4.1.0&q=85",
    location: "Marbella, Spain",
    name: "Coastal Villa Portfolio",
    value: "$22.9M",
    yield: "8.2%",
    status: "Funding",
  },
];

export const TEAM_IMAGE = "/brand/team.jpg";
export const BOARDROOM = ["/brand/boardroom-2.png", "/brand/boardroom-1.png", "/brand/boardroom-3.png"];

export const FAQS = [
  { q: "What is a Real World Asset (RWA) token?", a: "An RWA token is a regulated digital representation of a physical or financial asset — such as real estate, private credit or commodities — issued on-chain with enforceable legal rights." },
  { q: "Who can invest through AUVRA?", a: "AUVRA serves verified accredited and institutional investors. Eligibility is enforced programmatically based on your jurisdiction and accreditation status." },
  { q: "How is compliance handled?", a: "Every token embeds jurisdiction-aware compliance logic covering KYC/AML, transfer restrictions, lockups and audit trails, enforced automatically at the smart-contract layer." },
  { q: "Where are the underlying assets held?", a: "Underlying collateral is held by qualified custodians under legal structures that map one-to-one to the issued tokens, with independent attestations." },
  { q: "Can I trade tokens after purchase?", a: "Yes. Eligible tokens can be transferred on integrated compliant secondary markets, subject to any applicable lockups and jurisdiction controls." },
];

export const PARTNERS = ["Meridian Capital", "Northgate", "Halcyon", "Verity Bank", "Solstice", "Atlas Trust"];

export const FOOTER = {
  Platform: ["Overview", "Tokenized Assets", "AUR Token", "Secondary Market"],
  Solutions: ["Real Estate", "Private Credit", "Commodities", "Treasuries"],
  Resources: ["Documentation", "Whitepaper", "API", "Insights"],
  Company: ["About", "Careers", "Partnerships", "Contact"],
  Legal: ["Privacy Policy", "Terms", "Risk Disclosure", "Cookie Policy"],
};
